import {
	Collapse, Row, Col, Form, Select, DatePicker, AutoComplete, Input
}from 'antd'
import CustomInput from '../CustomInput'
import CustomButton from '../CustomButton'
import CustomSelect from '../CustomSelect'
import FilterIcon from '../Icons/filter.svg'
import ArrowIcon from '../Icons/arrow.svg'
import './style.css'

const CustomFilters = (props) => {
	const { elements= [], visibleButtons = true, setFilters } = props
	const [form] = Form.useForm()
	function getElement(element){
		function getComponent(component){
			function getName(item, names){
				return names.map(name => item[name]).join(" ")
			}
			switch (component?.type){
				case "input":
					return (
						<CustomInput
							placeholder={ component.placeholder }
							onChange={ (e) => {
								component.onChange ? component.onChange(e.target.value) : null
							} }
						/>
					)
				case "select":
					return (
						<CustomSelect
							allowClear
							showSearch
							filterOption={ !component.onSearch }
							getPopupContainer={ trigger => trigger.parentNode }
							maxTagCount={ 5 }
							mode={ component.multiple ? "multiple" : "single" }
							notFoundContent={ null }
							optionFilterProp="title"
							placeholder={ component.placeholder }
							onChange={ (value) => {
								component.onChange ? component.onChange(value) : null
							} }
							onSearch={ (value) => {
								component.onSearch ? component.onSearch(value) : null
							} }
						>
							{ Array.isArray(component.items) && component.items?.map(item => {
								return (
									<Select.Option
										key={ item.id }
										title={ getName(item, component.itemName) }
										value={ item.id }
									>
										{ getName(item, component.itemName) }
									</Select.Option>)
							}) }
						</CustomSelect>
					)
				case "autoComplete":
					return (
						<AutoComplete
							allowClear
							className="filterAutoComplete"
							filterOption={ false }
							getPopupContainer={ trigger => trigger.parentNode }
							notFoundContent={ null }
							options={ Array.isArray(component.items)
								? component.items?.map(item => {
									if (typeof item === "string"){
										return {
											value : item,
											label :
												<div
													className="activeItem"
													title={ item }
												>
													{ item }
												</div>
										}
									}
									return {
										value : item.name,
										label :
											<div
												className={ item.isDeleted ? "deletedItem" : "activeItem" }
												title={ `${ item.name } ${ item.isDeleted ? "(утратило актуальность)" : "" }`.trim() }
											>
												{ item.name }
											</div>
									}
								})
								: [] }
							size="large"
							onChange={ (value) => {
								component.onChange ? component.onChange(value) : null
							} }
							onClick={ (value) => {
								component.onChange ? component.onChange(value) : null
							} }
							onSearch={ (value) => {
								component.onSearch ? component.onSearch(value) : null
							} }
						>
							<CustomInput
								placeholder={ component.placeholder }
								type="input"
							/>
						</AutoComplete>
					)
				case "datePicker":
					return (
						<DatePicker.RangePicker
							allowClear
							allowEmpty={ [true, true] }
							format="DD.MM.YYYY"
							placeholder={ component.placeholder ?? undefined }
						/>
					)
				default:
					return null
			}
		}
		return (
			<Form.Item
				label={ element.label ?? "" }
				name={ element.name }
				style={ { width: "100%" } }
			>
				{ getComponent(element) }
			</Form.Item>
		)
	}

	function getValues(isReset){
		if (isReset)
			form.resetFields()

		if (setFilters)
		  setFilters(form.getFieldsValue())
	}

	return (
		<Collapse
			ghost
			bordered={ false }
			className="filter"
			expandIcon={ ({ isActive }) => (
				<img
					className={ isActive ? "rotate" : "" }
					src={ ArrowIcon }
				/>) }
		>
			<Collapse.Panel
				key="1"
				extra={ (<img src={ FilterIcon } />) }
				header="Фильтры"
			>
				<Form
					form={ form }
					labelCol={ { span: 5 } }
					onFinish={ () => getValues(false) }
				>
					<Row align="middle">
						<Col span={ visibleButtons ? 15 : 24 }>
							{ Array.isArray(elements) && elements.map(element => {
								return (
									<Row key={ element.name }>
										{ getElement(element) }
									</Row>
								)
							}) }
						</Col>
						{ Boolean(visibleButtons) && (
							<Col span={ 9 }>
								<Form.Item className="filterButton">
									<Row justify="end">
										<CustomButton
											size="small"
											type="grey"
											onClick={ () => {
												getValues(true)
											} }
										>
                      Очистить все
										</CustomButton>
										<CustomButton
											htmlType="submit"
											size="small"
											type="green"
										>
                      Применить фильтры
										</CustomButton>
									</Row>
								</Form.Item>
							</Col>
						) }
					</Row>
				</Form>
			</Collapse.Panel>
		</Collapse>
	)
}

export default CustomFilters